module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt3 mb2 flex flex-column"
  }, [_c('div', {
    staticClass: "congratulation-box flex flex-row pv3 ph3 mb4"
  }, [_c('medal', {
    attrs: {
      "height": "30px",
      "width": "30px"
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), (!_vm.isDataFilled) ? _c('ak-button', {
    attrs: {
      "customClass": "self-start",
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createACH.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    Connect Your Bank\n  ")]) : _c('div', {
    staticClass: "flex flex-column"
  }, [_c('akko-input', {
    staticClass: "email-input",
    attrs: {
      "inputValue": _vm.email,
      "isError": _vm.emailError,
      "setValue": _vm.setEmail,
      "errorMessage": "Please enter a valid email",
      "placeholder": "Email Address"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.bankAccountData.accounts), function(bankAccountData, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-row justify-between ttc mt3 responsive"
    }, [_c('div', {
      staticClass: "flex flex-column justify-center"
    }, [_c('div', {
      staticClass: "inter color-gray f7 mt2 selected"
    }, [_vm._v(" SELECTED ACCOUNT")]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-row justify-center mt2 responsive-info"
    }, [_c('div', {
      staticClass: "inter-medium color-gray f6"
    }, [_vm._v("\n          " + _vm._s(_vm.institutionName) + " - " + _vm._s(bankAccountData.type) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "inter color-gray f6 responsive-name"
    }, [_c('label', {
      staticClass: "separator"
    }, [_vm._v(" -")]), _vm._v("\n          " + _vm._s(bankAccountData.name) + " (" + _vm._s(bankAccountData.mask) + ")\n        ")])])]), _vm._v(" "), (_vm.isDataFilled) ? _c('ak-button', {
      attrs: {
        "customClass": "responsive-button fw7 f-btn",
        "newSecondary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.createACH.apply(null, arguments)
        }
      }
    }, [_vm._v("\n      Update Bank Details\n    ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.bankAccountError) ? _c('div', {
    staticClass: "balance-error-box flex flex-row pv2 ph2 mt3"
  }, [_c('div', {
    staticClass: "ml1 mr1 flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "inter color-theme f6"
  }, [_vm._v("\n        " + _vm._s(_vm.bankAccountError) + "\n      ")])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ml3 flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "inte color-gray f6"
  }, [_vm._v("\n        By registering a bank account, you will receive $20 in deductible credit toward future claims!\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e08e92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/formBox/BankAccount.vue
// module id = 802
// module chunks = 0